import React from 'react';
import classNames from 'classnames';

import propTypes from 'propTypes';

export const CLASSNAME_PRIMARY = 'Button--primary';
export const CLASSNAME_SECONDARY = 'Button--secondary';
export const CLASSNAME_CANCEL = 'Button--cancel';
export const CLASSNAME_KEY_ACTION = 'Button--key-action';
export const CLASSNAME_DELETE = 'Button--delete';
export const CLASSNAME_TOUPE = 'Button--toupe';
export const CLASSNAME_UNDERLINED = 'Button--underlined';
export const CLASSNAME_PILL = 'PillButton';

class BaseButton extends React.Component {
  static propTypes = {
    children: propTypes.node,
    element: propTypes.oneOfType([
      propTypes.element,
      propTypes.func,
      propTypes.node,
    ]),
    href: propTypes.string,
    target: propTypes.string,
    onClick: propTypes.func,
    processing: propTypes.bool,
    processingText: propTypes.string,
    type: propTypes.string,
    value: propTypes.string,
    analyticsEventName: propTypes.string,
    analyticsEventData: propTypes.object,
  };

  static defaultProps = {
    element: 'button',
    processingText: 'Processing...',
    disabled: false,
  };

  trackClick = el => {
    const { analyticsEventName, analyticsEventData, element } = this.props;
    if (!analyticsEventName) {
      return;
    }

    if (element === 'a') {
      analytics.trackLink(el, analyticsEventName, analyticsEventData);
    } else {
      analytics.track(analyticsEventName, analyticsEventData);
    }
  };

  handleClick = e => {
    const { disabled, onClick } = this.props;
    if (disabled) {
      // this naturally happens for button tags, but not for others tags/components
      e.preventDefault();
    } else {
      onClick && onClick(e);
    }
  };

  render() {
    const {
      children,
      processing,
      processingText,
      analyticsEventName,
      element,
      ...props
    } = this.props;

    const Element = element;

    return (
      <Element {...props} onClick={this.handleClick} ref={this.trackClick}>
        {processing ? <Processing text={processingText} /> : children}
      </Element>
    );
  }
}

const Processing = ({ text }) => (
  <div className="Button__processing">
    <div className="Spinner Button__spinner" />
    {text && <div className="Button__spinner-text">{text}</div>}
  </div>
);

const Button = props => (
  <BaseButton
    {...props}
    className={classNames(CLASSNAME_PRIMARY, props.className)}
  />
);

Button.Base = props => <BaseButton {...props} />;

Button.Delete = props => (
  <BaseButton
    {...props}
    className={classNames(CLASSNAME_DELETE, props.className)}
  />
);

Button.Toupe = props => (
  <BaseButton
    {...props}
    className={classNames(CLASSNAME_TOUPE, props.className)}
  />
);

Button.KeyAction = props => (
  <BaseButton
    {...props}
    className={classNames(CLASSNAME_KEY_ACTION, props.className)}
  />
);

Button.Secondary = props => (
  <BaseButton
    {...props}
    className={classNames(CLASSNAME_SECONDARY, props.className)}
  />
);

Button.Cancel = props => (
  <BaseButton
    {...props}
    className={classNames(CLASSNAME_CANCEL, props.className)}
  />
);

Button.Underlined = props => (
  <BaseButton
    {...props}
    className={classNames(CLASSNAME_UNDERLINED, props.className)}
  />
);

Button.Pill = ({ children, className, ...props }) => (
  <BaseButton
    element="div"
    processingText=""
    className={classNames('flat-blue', CLASSNAME_PILL, className, {
      'PillButton--checked': props.checked,
      'PillButton--processing': props.processing,
    })}
    {...props}
  >
    {children}
  </BaseButton>
);

export default Button;



// WEBPACK FOOTER //
// ./app/javascript/common/components/Button.js